const style = {
  accessManagement__label_mfaTypeSelector: {
    margin: '4px 8px 0 0',
    fontSize: '14px',
  },
  dropdownSelect__renderValue: {
    width: 'calc(90%)',
  },
};

export default style;
